import { DocumentNode, gql } from '@apollo/client'

export const UPDATE_CHILD_ASSMAT_SECTOR: DocumentNode = gql`
    mutation updateAssMatSector($daycareId: Int!, $parentId: Int!, $sectionIds: [Int], $primarySectionId: Int) {
        updateAssMatSector(
            daycareId: $daycareId
            parentId: $parentId
            sectionIds: $sectionIds
            primarySectionId: $primarySectionId
        )
    }
`

export const UPDATE_CHILD_ASSMAT_PRIORITY_GROUP: DocumentNode = gql`
    mutation updateAssMatPriorityGroup($daycareId: Int!, $parentId: Int!, $groupId: Int) {
        updateAssMatPriorityGroup(daycareId: $daycareId, parentId: $parentId, groupId: $groupId)
    }
`

export const DETACH_CHILD_ASSMAT: DocumentNode = gql`
    mutation detachChildAssMat($childId: Int!) {
        detachChildAssMat(childId: $childId)
    }
`
